import React, { useEffect, useState, Fragment, createElement, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, MessageSquare, X, Lock, Check, TrendingUp } from 'lucide-react';
import { useScreenInit } from './useScreenInit.js';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/7LBxnHifHEszohsnb2YYBf/AVY_LOGO.png';
const QR_CODE = 'https://cdn.magicpatterns.com/uploads/mty7WvpQictHZcsoU2UJsc/pasted-image.png';
const NATWEST_LOGO = 'https://cdn.magicpatterns.com/uploads/14JYWeFfSSgcPyYGWDWXnM/natwest-logo.png';
const WARWICK_LOGO = 'https://cdn.magicpatterns.com/uploads/nVjdVSHjwJfKFax4irgvhq/warwick.png';
const AVY_PROFILE = 'https://cdn.magicpatterns.com/uploads/dPc1daPUHuB5dUyGjajfUg/AvyPruthi_Profile_BW.png';
const NZ_IMAGE = 'https://cdn.magicpatterns.com/uploads/wAQphcBWWNHGHuMU1wzC5F/nz.jpg';
const EFFIE_AWARD = 'https://cdn.magicpatterns.com/uploads/1LHHJAx9EBeLeQe14j8iv3/effie.jpg';
const TRANSFORM_AWARDS = 'https://cdn.magicpatterns.com/uploads/hvEPBWtqhU7ruuhXDzLGjv/press-transform-awards.jpg';
const TRANSFORM_TEAM = 'https://cdn.magicpatterns.com/uploads/hhhuNAGTij4zSJyWsSXx2v/apruthi-grow-transform.jpg';
const PACQUIAO_DOHA = 'https://cdn.magicpatterns.com/uploads/kh3Tera9MPMWFYekxkFWyE/Manny_Pacquaio_arrives_to_Doha_0.jpg';
const LLAMA_PIC = 'https://cdn.magicpatterns.com/uploads/jz9awXzfiBokiBE6zJdx1b/PXL_20251228_061123752.jpg';
const MATT_PHOTO = 'https://cdn.magicpatterns.com/uploads/gJfMwR5Gsj1UP59px8fX41/matt-w.jpg';
const KIDZANIA_LOGO = 'https://cdn.magicpatterns.com/uploads/g9sK3Qh6s2YHDJ5UzYjV75/KidZania-Logo-1999.png';
const GMC_LOGO = 'https://cdn.magicpatterns.com/uploads/mzvA6wvseBLBU7THUyWcht/GMC-Logo.jpg';
const JLR_LOGO = 'https://cdn.magicpatterns.com/uploads/fFQTjrP6KZARRWKqH3rMLm/JLR_Logo_Border.png';
const AVERY_LOGO = 'https://cdn.magicpatterns.com/uploads/jYVqDHz5PxdQahXCHU8H55/averyweigh.png';
const AHLIBANK_LOGO = 'https://cdn.magicpatterns.com/uploads/tx83e22FBkrjUryASugdoa/ahlibank.png';
const OLYMPICS_LOGO = 'https://cdn.magicpatterns.com/uploads/rPc4Hms6pYeJjQSr8G8EVL/olympics.png';
const KIA_LOGO = 'https://cdn.magicpatterns.com/uploads/kYcGA91NqwDMhTmi42F88T/kia.webp';
const FULL_BIO_GRID = 'https://cdn.magicpatterns.com/uploads/7z2ZHSVyz6mescMtcwzbsC/avy-presentation-1920x1080.png';
const QATAR_OLYMPICS_LOGO = 'https://cdn.magicpatterns.com/uploads/rqB6Kpp1F4uQ3NxcY5Df8N/Qatar_Olympic_Committee_logo.svg.png';
const KIDZANIA_LOGO_ALT = 'https://cdn.magicpatterns.com/uploads/hogg68RLBXMj6X9ihUFeuT/KidZania-Logo-1999.png';
const AHLIBANK_LOGO_ALT = 'https://cdn.magicpatterns.com/uploads/9wYXnckAjhuhNs5dz3KkTF/ahlibank.png';
const JLR_LOGO_ALT = 'https://cdn.magicpatterns.com/uploads/vQtmfchRin1t6Zqbxem9ti/JLR_Logo_Border.png';
const KIA_LOGO_ALT = 'https://cdn.magicpatterns.com/uploads/xdmeH8JEkN3D2dTTfDLB3j/kia.webp';
const F1_VISUAL_NEW = 'https://cdn.magicpatterns.com/uploads/vpJ52rJZWLf8Ne4Z5UuhaS/Screenshot_2026-05-27_at_13.19.25.png';
const F1_VISUAL = 'https://cdn.magicpatterns.com/uploads/7LsdDJkJCazvsh62K3ku6a/f1.png';
const REVENUE_VISUAL = 'https://cdn.magicpatterns.com/uploads/2qivfs47o59ptZsaDxdku3/revenue.png';
const PRET_COFFEE = 'https://cdn.magicpatterns.com/uploads/bfpbjtu43PUqCNMCyWZJq3/pasted-image.jpg';
const CURRY_IMAGE = 'https://cdn.magicpatterns.com/uploads/vhTu1Tcwca3TApsuQBKvBt/Indian_Chicken_Curry_3.webp';
const ETIHAD_PLANE = 'https://cdn.magicpatterns.com/uploads/uLvWpwobQZZkGKxPWBnoKg/eithad.jpg';
const SIT_RIGHT_IMAGE = 'https://cdn.magicpatterns.com/uploads/1kQNk8cw1gNSNAeXRxM1xx/sit-right.webp';
const PRET_GESTURE_IMAGE = 'https://cdn.magicpatterns.com/uploads/wGzBWmNR2AgQLbqcVDBakb/Screenshot_2026-05-27_at_15.18.28.png';
const BATMAN_MEME = 'https://cdn.magicpatterns.com/uploads/g1Uzqye2QPfzVt6cG58Bxe/brand-logo.jpg';
const TRIANGLE_1 = 'https://cdn.magicpatterns.com/uploads/fbspeiCpVXAvL1EH7Dv8bJ/avy-presentation-triangle-1.png';
const TRIANGLE_2 = 'https://cdn.magicpatterns.com/uploads/1pBs8VUz4Yq9LXxhXjuusX/avy-presentation-triangle-2.png';
interface SlideProps {
  isActive: boolean;
}
// --- Layout Wrapper for Slides ---
const SlideLayout = ({
  children,
  theme = 'light',
  showFooter = true,
  showLogo = true,
  footerTitle = 'How brand clarity maximises your funnel.'
}: {
  children: React.ReactNode;
  theme?: 'light' | 'dark' | 'yellow' | 'red' | 'navy' | 'green';
  showFooter?: boolean;
  showLogo?: boolean;
  footerTitle?: string;
}) => {
  const bgClass = {
    light: 'bg-[#fcfcfc] text-slate-900',
    dark: 'bg-[#0f172a] text-white',
    yellow: 'bg-yellow-400 text-black',
    red: 'bg-[#ff3b30] text-white',
    navy: 'bg-[#1a2b3c] text-white',
    green: 'bg-[#34c759] text-white'
  }[theme];
  return <div className={`relative h-full w-full flex flex-col px-6 md:px-24 py-12 md:py-20 overflow-hidden ${bgClass}`} data-id="element-0">
      {showLogo && <div className="absolute top-6 md:top-8 right-6 md:right-12 z-10" data-id="element-1">
          <img src={LOGO_URL} alt="AVY" className="w-8 h-8 md:w-10 md:h-10 object-contain" data-id="element-2" />
        </div>}

      <div className="flex-1 flex flex-col justify-center min-h-0" data-id="element-3">
        {children}
      </div>

      {showFooter && <div className="mt-6 md:mt-12 flex justify-between items-end text-[7px] md:text-[9px] uppercase tracking-[0.2em] font-bold text-[#ff3b30] opacity-80 flex-shrink-0" data-id="element-4">
          <div className="hidden md:block" data-id="element-5">AVY® | Confidential</div>
          <div className="text-center flex-1 md:flex-initial" data-id="element-6">
            {footerTitle}
          </div>
          <div className="hidden md:block text-right" data-id="element-7">www.avy.me</div>
        </div>}

      <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#ff3b30]" data-id="element-8" />
    </div>;
};
// --- Slide Components ---
const TitleSlide = ({
  isActive
}: SlideProps) => <SlideLayout theme="light" showLogo={false} data-id="element-9">
    <div className="flex flex-col md:flex-row items-center justify-between gap-12 h-full" data-id="element-10">
      <div className="flex-1 max-w-3xl" data-id="element-11">
        <motion.img src={LOGO_URL} className="w-20 h-20 mb-12" initial={{
        opacity: 0
      }} animate={isActive ? {
        opacity: 1
      } : {}} data-id="element-12" />
        <motion.h1 className="text-6xl md:text-[5.5rem] font-black leading-[1.1] tracking-tighter text-slate-900" initial={{
        opacity: 0,
        x: -50
      }} animate={isActive ? {
        opacity: 1,
        x: 0
      } : {}} data-id="element-13">
          How brand clarity <span className="block" data-id="element-14">maximises your</span>{' '}
          <span className="block" data-id="element-15">funnel.</span>
        </motion.h1>
        <div className="h-1 bg-[#ff3b30] w-32 my-12" data-id="element-16" />
        <motion.p className="text-2xl md:text-3xl font-medium text-slate-800" initial={{
        opacity: 0
      }} animate={isActive ? {
        opacity: 1
      } : {}} transition={{
        delay: 0.4
      }} data-id="element-17">
          Your funnel doesn't need bigger. It needs{' '}
          <span className="bg-yellow-400 px-2 py-1 text-black" data-id="element-18">better.</span>
        </motion.p>
      </div>

      <div className="flex flex-col items-center md:items-end gap-16" data-id="element-19">
        <motion.div className="flex flex-row md:flex-col gap-12 items-center md:items-end opacity-90" initial={{
        opacity: 0,
        x: 50
      }} animate={isActive ? {
        opacity: 1,
        x: 0
      } : {}} transition={{
        delay: 0.5
      }} data-id="element-20">
          <img src={NATWEST_LOGO} alt="Natwest" className="h-10 md:h-14 object-contain" data-id="element-21" />
          <img src={WARWICK_LOGO} alt="Warwick" className="h-10 md:h-14 object-contain" data-id="element-22" />
        </motion.div>

        <motion.div className="relative group" initial={{
        opacity: 0,
        scale: 0.8
      }} animate={isActive ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        delay: 0.7,
        type: 'spring'
      }} data-id="element-23">
          <div className="absolute -inset-4 bg-yellow-400/20 rounded-[2rem] blur-2xl group-hover:bg-yellow-400/30 transition-all" data-id="element-24" />
          <div className="relative p-6 bg-white shadow-2xl rounded-3xl border-2 border-slate-100" data-id="element-25">
            <img src={QR_CODE} alt="Connect on LinkedIn" className="w-32 md:w-40" data-id="element-26" />
            <div className="absolute -top-3 -right-3 bg-[#ff3b30] text-white text-[10px] font-black px-4 py-1.5 rounded-full shadow-xl rotate-12" data-id="element-27">
              LET'S CONNECT
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  </SlideLayout>;
const BioSlide = ({
  isActive
}: SlideProps) => {
  return <SlideLayout theme="light" showLogo={false} data-id="element-28">
      <div className="relative w-full h-full flex items-center justify-center overflow-hidden" data-id="element-29">
        <motion.div className="w-full h-full flex items-center justify-center" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isActive ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-30">
          <img src={FULL_BIO_GRID} className="w-full h-full object-contain" alt="Avy Pruthi - Experience and Partners" data-id="element-31" />
        </motion.div>
      </div>
    </SlideLayout>;
};
const StoryTemplateSlide = ({
  isActive
}: SlideProps) => <SlideLayout theme="light" data-id="element-32">
    <div className="flex flex-col items-center justify-center h-full text-center" data-id="element-33">
      <span className="text-xs font-bold uppercase tracking-widest text-gray-400 border-b border-gray-300 pb-1 mb-6" data-id="element-34">
        How I Got Here
      </span>
      <motion.h2 className="text-6xl md:text-9xl font-black tracking-tighter text-slate-900" initial={{
      opacity: 0,
      y: 20
    }} animate={isActive ? {
      opacity: 1,
      y: 0
    } : {}} data-id="element-35">
        My Story
      </motion.h2>

      <motion.div className="absolute top-1/4 right-1/4 rotate-12 font-['Caveat',_cursive] text-3xl text-red-500 opacity-80" initial={{
      opacity: 0,
      scale: 0.5
    }} animate={isActive ? {
      opacity: 0.8,
      scale: 1
    } : {}} transition={{
      delay: 1
    }} data-id="element-36">
        Adam - Wall :-)
      </motion.div>
    </div>
  </SlideLayout>;
const WeakBrandingCostSlide = ({
  isActive
}: SlideProps) => <SlideLayout theme="light" data-id="element-37">
    <div className="max-w-6xl" data-id="element-38">
      <span className="text-xs font-bold uppercase tracking-widest text-slate-400 border-b border-slate-200 pb-1" data-id="element-39">
        The Real Cost
      </span>
      <motion.h2 className="text-5xl md:text-7xl font-black mt-6 mb-10 tracking-tighter text-slate-900" initial={{
      opacity: 0,
      y: 20
    }} animate={isActive ? {
      opacity: 1,
      y: 0
    } : {}} data-id="element-40">
        What weak branding can cost you.
      </motion.h2>
      <div className="max-w-5xl space-y-4" data-id="element-41">
        {[{
        title: 'Leads that go cold',
        desc: 'Prospects visit, feel uncertain, and move on — without saying why'
      }, {
        title: 'Price objections on every call',
        desc: "Price objections rise when the brand hasn't pre‑sold value"
      }, {
        title: 'Slower growth',
        desc: "Word of mouth works less when people can't easily describe what you do"
      }, {
        title: 'Wrong-fit clients',
        desc: 'Vague brands attract vague enquiries — which waste time and energy'
      }].map((item, i) => <motion.div key={i} className="flex items-center gap-6 bg-slate-50 p-5 rounded-xl border border-slate-100" initial={{
        opacity: 0,
        x: -20
      }} animate={isActive ? {
        opacity: 1,
        x: 0
      } : {}} transition={{
        delay: i * 0.1
      }} data-id="element-42">
            <div className="w-1/3 text-[#ff3b30] font-black text-xl md:text-2xl" data-id="element-43">
              {item.title}
            </div>
            <div className="w-[2px] h-10 bg-slate-200" data-id="element-44" />
            <div className="flex-1 text-slate-600 text-base md:text-lg" data-id="element-45">
              {item.desc}
            </div>
          </motion.div>)}
      </div>
    </div>
  </SlideLayout>;
const ExerciseSlide = ({
  isActive
}: SlideProps) => <SlideLayout theme="navy" data-id="element-46">
    <div className="flex items-center justify-between gap-12" data-id="element-47">
      <motion.h2 className="text-5xl md:text-8xl font-black tracking-tighter leading-tight max-w-5xl text-yellow-500" initial={{
      opacity: 0,
      scale: 0.9
    }} animate={isActive ? {
      opacity: 1,
      scale: 1
    } : {}} data-id="element-48">
        What's your biggest branding challenge right now?
      </motion.h2>
      <motion.div className="text-9xl md:text-[12rem] bg-white rounded-2xl p-4" animate={isActive ? {
      rotate: [0, 10, -10, 10, 0]
    } : {}} transition={{
      repeat: Infinity,
      duration: 3
    }} data-id="element-49">
        🤔
      </motion.div>
    </div>
  </SlideLayout>;
const CredentialsSlide = ({
  isActive
}: SlideProps) => <SlideLayout theme="dark" data-id="element-50">
    <motion.img src={LOGO_URL} className="w-20 h-20 mb-12" initial={{
    opacity: 0
  }} animate={isActive ? {
    opacity: 1
  } : {}} data-id="element-51" />
    <motion.h2 className="text-6xl md:text-9xl font-black tracking-tighter" initial={{
    opacity: 0,
    x: -50
  }} animate={isActive ? {
    opacity: 1,
    x: 0
  } : {}} data-id="element-52">
      Credentials
    </motion.h2>
    <div className="h-1 bg-[#ff3b30] w-48 mt-8" data-id="element-53" />
  </SlideLayout>;
const BrandIsNotSlide = ({
  isActive
}: SlideProps) => <SlideLayout theme="light" data-id="element-54">
    <div className="flex flex-col md:flex-row items-center gap-12 h-full" data-id="element-55">
      <div className="flex-1" data-id="element-56">
        <motion.h2 className="text-4xl md:text-6xl font-black mb-12 tracking-tighter text-red-600" initial={{
        opacity: 0
      }} animate={isActive ? {
        opacity: 1
      } : {}} data-id="element-57">
          Brand is NOT.
        </motion.h2>
        <div className="bg-red-50 p-10 rounded-[2.5rem] border-2 border-red-100 shadow-sm" data-id="element-58">
          <ul className="space-y-8 text-2xl md:text-4xl font-black text-red-600" data-id="element-59">
            {['A logo', 'A colour palette', 'A font choice', 'A website redesign', 'A tagline'].map((item, i) => <motion.li key={i} className="flex items-center gap-6" initial={{
            opacity: 0,
            x: -20
          }} animate={isActive ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            delay: i * 0.1
          }} data-id="element-60">
                <span className="text-4xl" data-id="element-61">✕</span> {item}
              </motion.li>)}
          </ul>
        </div>
      </div>

      <motion.div className="flex-1 h-full py-12" initial={{
      opacity: 0,
      scale: 0.9,
      rotate: 5
    }} animate={isActive ? {
      opacity: 1,
      scale: 1,
      rotate: 0
    } : {}} transition={{
      delay: 0.5,
      type: 'spring'
    }} data-id="element-62">
        <div className="relative group h-full" data-id="element-63">
          <div className="absolute -inset-4 bg-red-600/10 rounded-[2rem] blur-2xl opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-64" />
          <img src={BATMAN_MEME} className="w-full h-full object-contain rounded-3xl shadow-2xl border-4 border-white relative z-10" alt="Batman Meme" data-id="element-65" />
        </div>
      </motion.div>
    </div>
  </SlideLayout>;
const BrandIsSlide = ({
  isActive
}: SlideProps) => <SlideLayout theme="green" data-id="element-66">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 h-full items-center" data-id="element-67">
      {/* Brand is NOT */}
      <motion.div initial={{
      opacity: 0,
      x: -30
    }} animate={isActive ? {
      opacity: 1,
      x: 0
    } : {}} transition={{
      delay: 0.1
    }} data-id="element-68">
        <h2 className="text-4xl md:text-5xl font-black mb-8 tracking-tighter text-red-600 opacity-50" data-id="element-69">
          Brand is NOT.
        </h2>
        <div className="bg-red-50/50 p-8 rounded-[2rem] border border-red-100" data-id="element-70">
          <ul className="space-y-4 text-xl md:text-2xl font-bold text-red-600/60" data-id="element-71">
            {['A logo', 'A colour palette', 'A font choice', 'A website redesign', 'A tagline'].map((item, i) => <li key={i} className="flex items-center gap-4" data-id="element-72">
                <span className="text-2xl" data-id="element-73">✕</span> {item}
              </li>)}
          </ul>
        </div>
      </motion.div>

      {/* Brand IS */}
      <motion.div initial={{
      opacity: 0,
      x: 30
    }} animate={isActive ? {
      opacity: 1,
      x: 0
    } : {}} transition={{
      delay: 0.3
    }} data-id="element-74">
        <h2 className="text-4xl md:text-6xl font-black mb-8 tracking-tighter text-green-600" data-id="element-75">
          Brand IS.
        </h2>
        <div className="bg-green-50 p-10 rounded-[2.5rem] border-2 border-green-100 shadow-xl" data-id="element-76">
          <ul className="space-y-6 text-2xl md:text-4xl font-black text-green-600" data-id="element-77">
            {[{
            label: 'Perception',
            desc: 'how they feel'
          }, {
            label: 'Trust',
            desc: 'the shortcut'
          }, {
            label: 'Positioning',
            desc: 'why you'
          }, {
            label: 'Promise',
            desc: 'the experience'
          }, {
            label: 'Voice',
            desc: 'how you sound'
          }].map((item, i) => <motion.li key={i} className="flex items-start gap-6" initial={{
            opacity: 0,
            x: 20
          }} animate={isActive ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            delay: 0.5 + i * 0.1
          }} data-id="element-78">
                <span className="text-4xl mt-1" data-id="element-79">✓</span>
                <div data-id="element-80">
                  {item.label}
                  <span className="block text-slate-400 font-normal text-lg" data-id="element-81">
                    — {item.desc}
                  </span>
                </div>
              </motion.li>)}
          </ul>
        </div>
      </motion.div>
    </div>
  </SlideLayout>;
const ProblemSlide = ({
  isActive,
  title = "What's Holding Brands Back?"
}: SlideProps & {
  title?: string;
}) => <SlideLayout theme="light" data-id="element-82">
    <div className="max-w-6xl" data-id="element-83">
      <span className="text-xs font-bold uppercase tracking-widest text-slate-400 border-b border-slate-200 pb-1" data-id="element-84">
        The Problem
      </span>
      <motion.h2 className="text-6xl md:text-8xl font-black mt-8 mb-16 tracking-tighter text-slate-900" initial={{
      opacity: 0,
      y: 20
    }} animate={isActive ? {
      opacity: 1,
      y: 0
    } : {}} data-id="element-85">
        {title}
      </motion.h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-86">
        {[{
        title: 'Unclear positioning',
        desc: "Prospects can't tell what makes you different — so they go elsewhere"
      }, {
        title: 'DIY brand chaos',
        desc: "Pieced-together visuals and copy that don't connect or convert"
      }, {
        title: 'Undercharging',
        desc: 'Without brand trust, price becomes the only lever'
      }, {
        title: 'No perceived authority',
        desc: 'Hard to command premium prices without a brand that backs it up'
      }, {
        title: 'Inconsistent presence',
        desc: 'Mixed messages across platforms create confusion, not confidence'
      }].map((p, i) => <motion.div key={i} className="bg-slate-50 p-8 rounded-2xl border border-slate-100 flex items-start gap-6" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={isActive ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        delay: 0.2 + i * 0.1
      }} data-id="element-87">
            <div className="w-1.5 h-12 bg-red-500 shrink-0" data-id="element-88" />
            <div data-id="element-89">
              <h3 className="text-2xl font-black mb-2 text-slate-900" data-id="element-90">
                {p.title}
              </h3>
              <p className="text-slate-500 text-lg leading-relaxed" data-id="element-91">{p.desc}</p>
            </div>
          </motion.div>)}
      </div>
    </div>
  </SlideLayout>;
const WrapUpSlide = ({
  isActive
}: SlideProps) => <SlideLayout theme="yellow" data-id="element-92">
    <motion.h2 className="text-6xl md:text-9xl font-black tracking-tighter mb-16" initial={{
    opacity: 0,
    y: 50
  }} animate={isActive ? {
    opacity: 1,
    y: 0
  } : {}} data-id="element-93">
      Before we wrap up.
    </motion.h2>
    <div className="max-w-4xl space-y-8 text-xl md:text-2xl font-medium leading-relaxed" data-id="element-94">
      <motion.p initial={{
      opacity: 0
    }} animate={isActive ? {
      opacity: 1
    } : {}} transition={{
      delay: 0.3
    }} data-id="element-95">
        "Brand clarity isn't magic. It's not a secret. It's not something only
        big companies with big budgets can access."
      </motion.p>
      <motion.p initial={{
      opacity: 0
    }} animate={isActive ? {
      opacity: 1
    } : {}} transition={{
      delay: 0.5
    }} data-id="element-96">
        "It just takes being honest. About who you are. Who you're genuinely
        for. What you really do. What makes you actually different."
      </motion.p>
      <motion.p className="font-black text-3xl" initial={{
      opacity: 0
    }} animate={isActive ? {
      opacity: 1
    } : {}} transition={{
      delay: 0.7
    }} data-id="element-97">
        "The more specific you are, the more magnetic you become to exactly the
        right people."
      </motion.p>
    </div>
  </SlideLayout>;
const SummarySlide = ({
  isActive
}: SlideProps) => {
  const items = [{
    area: 'Why brands fail to convert',
    insight: 'Weak brand clarity creates invisible, expensive leaks in your funnel'
  }, {
    area: 'What brand really is',
    insight: "Not a logo — it's perception, trust, positioning, promise, and voice. Pret gives away coffee to create loyalty worth thousands. Airlines remove row 13 because brand is a feeling. A restaurant in Benidorm fills 400 covers a day through service, not signage."
  }, {
    area: 'The brand–revenue link',
    insight: "A circular relationship: clarity → trust → better prices → referrals → stronger brand. Brand loyalty isn't a points card — it's a feeling. When you create it, the funnel feeds itself."
  }, {
    area: 'A · Align',
    insight: 'Why, who, what, how, where — get your story straight before anything else'
  }, {
    area: 'V · Visualise',
    insight: 'Express it visually and verbally, across every digital touchpoint — website, social, email, proposals. Clarity converts attention into opportunity.'
  }, {
    area: 'Y · Your Outcome',
    insight: 'When A and V are right, better clients, better prices, and real growth follow'
  }, {
    area: 'Positioning',
    insight: 'The live positioning exercise — your one-liner must be specific, clear, and valuable, in one sentence. This is how you attract the right clients.'
  }, {
    area: 'Examples',
    insight: 'HVAC landed their biggest contract. Avery stayed the global leader.'
  }];
  return <SlideLayout theme="light" data-id="element-98">
      <motion.h2 className="text-4xl md:text-6xl font-black mb-8 tracking-tighter text-slate-900" initial={{
      opacity: 0
    }} animate={isActive ? {
      opacity: 1
    } : {}} data-id="element-99">
        What we covered today
      </motion.h2>
      <div className="space-y-1 pr-4 pb-4" data-id="element-100">
        <div className="flex text-[10px] uppercase tracking-widest font-bold text-[#ff3b30] mb-2" data-id="element-101">
          <div className="w-1/4" data-id="element-102">Area</div>
          <div className="flex-1" data-id="element-103">The key insight</div>
        </div>
        {items.map((item, i) => <motion.div key={i} className="flex py-2 border-t border-slate-100 items-start" initial={{
        opacity: 0,
        x: -20
      }} animate={isActive ? {
        opacity: 1,
        x: 0
      } : {}} transition={{
        delay: 0.1 * i
      }} data-id="element-104">
            <div className="w-1/4 font-black text-slate-900 pr-4 text-sm" data-id="element-105">
              {item.area}
            </div>
            <div className="flex-1 text-slate-600 text-xs md:text-sm leading-snug" data-id="element-106">
              {item.insight}
            </div>
          </motion.div>)}
      </div>
      <motion.div className="mt-4 p-6 bg-slate-50 rounded-xl border border-slate-100" initial={{
      opacity: 0
    }} animate={isActive ? {
      opacity: 1
    } : {}} transition={{
      delay: 1
    }} data-id="element-107">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-108">
          <div className="space-y-2 flex-1" data-id="element-109">
            <p className="text-base font-black text-slate-900" data-id="element-110">
              Gift: I'm here all day, also happy to do a brand clarity session,
              90mins session comp.
            </p>
            <p className="text-sm text-slate-600 font-medium" data-id="element-111">
              I have a small request — feedback.
            </p>
          </div>
          <a href="https://www.ws.avy.me/" className="text-[#ff3b30] font-black underline text-lg whitespace-nowrap" data-id="element-112">
            https://www.ws.avy.me/
          </a>
        </div>
      </motion.div>
    </SlideLayout>;
};
// --- Full 29 Slide Config ---
const SLIDE_CONFIG = [{
  id: 'title',
  component: TitleSlide,
  notes: "Welcome. Let's talk about brand clarity."
}, {
  id: 'discovery',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="yellow" data-id="element-113">
        <motion.h2 className="text-5xl md:text-8xl font-black mb-16 tracking-tighter leading-tight max-w-4xl" initial={{
      opacity: 0,
      scale: 0.95
    }} animate={isActive ? {
      opacity: 1,
      scale: 1
    } : {}} data-id="element-114">
          In the next 90'ish' mins, you'll discover.
        </motion.h2>
        <div className="space-y-8" data-id="element-115">
          {['Exactly how branding drives real revenue', 'What brand clarity actually means', 'A three-part framework you can start using', 'Real client stories', 'A gift for everyone in this room'].map((item, i) => <motion.div key={i} className="flex items-start gap-6 text-xl md:text-2xl font-bold max-w-3xl" initial={{
        opacity: 0,
        y: 20
      }} animate={isActive ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.1 * i + 0.3
      }} data-id="element-116">
              <span className="w-8 h-[2px] bg-black mt-4 shrink-0" data-id="element-117"></span>
              {item}
            </motion.div>)}
        </div>
        <motion.div className="absolute top-32 right-12 md:right-24 text-8xl md:text-[12rem] opacity-40" initial={{
      opacity: 0,
      y: 50
    }} animate={isActive ? {
      opacity: 0.6,
      y: [0, -30, 0]
    } : {}} transition={{
      y: {
        repeat: Infinity,
        duration: 4,
        ease: 'easeInOut'
      },
      opacity: {
        duration: 0.8
      }
    }} data-id="element-118">
          🙏
        </motion.div>
      </SlideLayout>,
  notes: "What you're walking away with."
}, {
  id: 'agenda',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="light" data-id="element-119">
        <motion.h2 className="text-5xl md:text-7xl font-black mb-16 tracking-tighter" initial={{
      opacity: 0,
      y: -20
    }} animate={isActive ? {
      opacity: 1,
      y: 0
    } : {}} data-id="element-120">
          Today's agenda.
        </motion.h2>
        <div className="space-y-6" data-id="element-121">
          {['The problem', 'What branding actually is', 'The brand-revenue link', 'A 3-part framework', 'How to position yourself', 'Real client stories', 'Your next steps'].map((item, i) => <motion.div key={i} className="flex items-center gap-6 text-xl md:text-2xl font-bold" initial={{
        opacity: 0,
        x: -20
      }} animate={isActive ? {
        opacity: 1,
        x: 0
      } : {}} transition={{
        delay: 0.1 * i + 0.3
      }} data-id="element-122">
              <span className="w-8 h-[2px] bg-[#ff3b30]" data-id="element-123"></span>
              <span className="text-gray-400 mr-2" data-id="element-124">{i + 1} ·</span>
              {item}
            </motion.div>)}
        </div>
      </SlideLayout>,
  notes: 'Seven areas. All connected.'
}, {
  id: 'bio',
  component: BioSlide,
  notes: 'Background and motivation.'
}, {
  id: 'deal',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="light" data-id="element-125">
        <motion.h2 className="text-3xl font-bold text-gray-400 uppercase tracking-widest mb-12" initial={{
      opacity: 0
    }} animate={isActive ? {
      opacity: 1
    } : {}} data-id="element-126">
          Deal?
        </motion.h2>
        <div className="max-w-5xl space-y-12 text-2xl md:text-4xl font-medium leading-tight text-gray-800" data-id="element-127">
          <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isActive ? {
        opacity: 1,
        y: 0
      } : {}} data-id="element-128">
            In the next 90 mins — i'll share a series of short stories which
            will help you think about branding for your business most
            importantly, how it increases revenue.
          </motion.p>
          <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isActive ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.2
      }} data-id="element-129">
            During the session we'll do a few activities. As cheesy as this
            sounds, for you to leave with value, i'd like you to be{' '}
            <span className="underline decoration-yellow-400 decoration-4 underline-offset-8" data-id="element-130">
              open, honest and transparent
            </span>{' '}
            about where you are with your business.
          </motion.p>
          <motion.p className="text-5xl md:text-7xl font-black text-black pt-8" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={isActive ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        delay: 0.4
      }} data-id="element-131">
            Ok, lets do it.
          </motion.p>
        </div>
      </SlideLayout>,
  notes: 'Setting the stage.'
}, {
  id: 'problem-1',
  component: (props: SlideProps) => <ProblemSlide {...props} title="What's holding brands back?" data-id="element-132" />,
  notes: 'The core problem.'
}, {
  id: 'question',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="light" data-id="element-133">
        <div className="max-w-5xl space-y-12 relative" data-id="element-134">
          <motion.h2 className="text-4xl md:text-6xl font-black tracking-tighter text-[#ff3b30]" initial={{
        opacity: 0
      }} animate={isActive ? {
        opacity: 1
      } : {}} data-id="element-135">
            Before I tell you what brand is...
          </motion.h2>
          <div className="space-y-8" data-id="element-136">
            {['Who here has ever watched a less experienced competitor win the deal you should have landed?', "How many of you have been told you're 'too expensive' even when you know your price is completely fair?", 'Has anyone had a prospect go from engaged and excited to radio-silent, with no clear reason why?'].map((q, i) => <motion.p key={i} className="text-2xl md:text-4xl font-bold text-slate-900 leading-tight flex items-start gap-4" initial={{
          opacity: 0,
          x: -30
        }} animate={isActive ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          delay: 0.3 + i * 0.2
        }} data-id="element-137">
                <span className="text-4xl md:text-5xl shrink-0" data-id="element-138">👋</span>
                <span data-id="element-139">{q}</span>
              </motion.p>)}
          </div>
        </div>
      </SlideLayout>,
  notes: 'Interactive questions.'
}, {
  id: 'brand-is-not',
  component: BrandIsNotSlide,
  notes: 'What branding is NOT.'
}, {
  id: 'brand-is',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="light" data-id="element-140">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 h-full items-center" data-id="element-141">
          {/* Brand is NOT */}
          <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={isActive ? {
        opacity: 1,
        x: 0
      } : {}} transition={{
        delay: 0.1
      }} data-id="element-142">
            <h2 className="text-4xl md:text-5xl font-black mb-8 tracking-tighter text-red-600 opacity-50" data-id="element-143">
              Brand is NOT.
            </h2>
            <div className="bg-red-50/50 p-8 rounded-[2rem] border border-red-100" data-id="element-144">
              <ul className="space-y-4 text-xl md:text-2xl font-bold text-red-600/60" data-id="element-145">
                {['A logo', 'A colour palette', 'A font choice', 'A website redesign', 'A tagline'].map((item, i) => <li key={i} className="flex items-center gap-4" data-id="element-146">
                    <span className="text-2xl" data-id="element-147">✕</span> {item}
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* Brand IS */}
          <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={isActive ? {
        opacity: 1,
        x: 0
      } : {}} transition={{
        delay: 0.3
      }} data-id="element-148">
            <h2 className="text-4xl md:text-6xl font-black mb-8 tracking-tighter text-green-600" data-id="element-149">
              Brand IS.
            </h2>
            <div className="bg-green-50 p-10 rounded-[2.5rem] border-2 border-green-100 shadow-xl" data-id="element-150">
              <ul className="space-y-6 text-2xl md:text-4xl font-black text-green-600" data-id="element-151">
                {[{
              label: 'Perception',
              desc: 'how they feel'
            }, {
              label: 'Trust',
              desc: 'the shortcut'
            }, {
              label: 'Positioning',
              desc: 'why you'
            }, {
              label: 'Promise',
              desc: 'the experience'
            }, {
              label: 'Voice',
              desc: 'how you sound'
            }].map((item, i) => <motion.li key={i} className="flex items-start gap-6" initial={{
              opacity: 0,
              x: 20
            }} animate={isActive ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              delay: 0.5 + i * 0.1
            }} data-id="element-152">
                    <span className="text-4xl mt-1" data-id="element-153">✓</span>
                    <div data-id="element-154">
                      {item.label}
                      <span className="block text-slate-400 font-normal text-lg" data-id="element-155">
                        — {item.desc}
                      </span>
                    </div>
                  </motion.li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </SlideLayout>,
  notes: 'What branding IS.'
}, {
  id: 'problem-2',
  component: WeakBrandingCostSlide,
  notes: 'The real cost of weak branding.'
}, {
  id: 'exercise',
  component: ExerciseSlide,
  notes: 'Roundtable discussion.'
}, {
  id: 'credibility',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="light" data-id="element-156">
        <motion.h2 className="text-5xl md:text-7xl font-black mb-12 tracking-tighter" initial={{
      opacity: 0,
      y: -20
    }} animate={isActive ? {
      opacity: 1,
      y: 0
    } : {}} data-id="element-157">
          Here's how I know this.
        </motion.h2>
        <div className="max-w-5xl space-y-12" data-id="element-158">
          <div className="flex flex-col md:flex-row items-baseline gap-8" data-id="element-159">
            <motion.p className="text-2xl md:text-4xl font-bold text-slate-900 leading-tight" initial={{
          opacity: 0
        }} animate={isActive ? {
          opacity: 1
        } : {}} data-id="element-160">
              <span className="text-6xl md:text-9xl font-black block mb-4" data-id="element-161">
                I
              </span>
              spent 15 years working on brand projects for a number of
              recognised organisations
            </motion.p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-5 gap-6 items-center pt-8" data-id="element-162">
            {[QATAR_OLYMPICS_LOGO, KIDZANIA_LOGO_ALT, AHLIBANK_LOGO_ALT, JLR_LOGO_ALT, KIA_LOGO_ALT, NATWEST_LOGO, WARWICK_LOGO, KIDZANIA_LOGO, AHLIBANK_LOGO, JLR_LOGO].map((logo, i) => <motion.div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex items-center justify-center h-32 md:h-40" initial={{
          opacity: 0,
          y: 20
        }} animate={isActive ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 0.2 + i * 0.1
        }} data-id="element-163">
                <img src={logo} className="max-h-full max-w-full object-contain" alt="Partner Logo" data-id="element-164" />
              </motion.div>)}
          </div>
        </div>
      </SlideLayout>,
  notes: 'Experience at scale.'
}, {
  id: 'realization',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="light" data-id="element-165">
        <div className="flex flex-col md:flex-row items-center gap-12 h-full" data-id="element-166">
          <div className="flex-1 flex flex-col justify-center" data-id="element-167">
            <motion.h2 className="text-5xl md:text-7xl font-black mb-12 tracking-tighter" initial={{
          opacity: 0,
          x: -30
        }} animate={isActive ? {
          opacity: 1,
          x: 0
        } : {}} data-id="element-168">
              But here's what I realised.
            </motion.h2>
            <div className="max-w-2xl space-y-8 text-xl md:text-2xl text-gray-700 leading-relaxed" data-id="element-169">
              <p data-id="element-170">
                The founders who needed it most had no access to any of it. It
                was locked behind agencies and big retainers.
              </p>
              <p className="text-3xl font-black text-black" data-id="element-171">
                It just didn't sit right with me.
              </p>
            </div>
          </div>
          <motion.div className="flex-1 h-full py-8" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={isActive ? {
        opacity: 1,
        scale: 1
      } : {}} data-id="element-172">
            <img src={SIT_RIGHT_IMAGE} className="w-full h-full object-cover rounded-3xl shadow-2xl" alt="Realization" data-id="element-173" />
          </motion.div>
        </div>
      </SlideLayout>,
  notes: 'The gap in the market.'
}, {
  id: 'decision',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="light" data-id="element-174">
        <motion.h2 className="text-5xl md:text-7xl font-black mb-12 tracking-tighter" initial={{
      opacity: 0,
      y: -20
    }} animate={isActive ? {
      opacity: 1,
      y: 0
    } : {}} data-id="element-175">
          So I made a decision.
        </motion.h2>
        <div className="max-w-4xl space-y-8 text-xl md:text-2xl text-gray-700 leading-relaxed" data-id="element-176">
          <p data-id="element-177">
            I decided to take everything I learned from the big guys and give it
            to the people who actually move the needle.
          </p>
        </div>
      </SlideLayout>,
  notes: 'So I made a decision.'
}, {
  id: 'proof',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="light" data-id="element-178">
        <motion.h2 className="text-5xl md:text-7xl font-black mb-12 tracking-tighter" initial={{
      opacity: 0,
      scale: 0.9
    }} animate={isActive ? {
      opacity: 1,
      scale: 1
    } : {}} data-id="element-179">
          My first client proved it.
        </motion.h2>
        <div className="max-w-4xl space-y-8 text-xl md:text-2xl text-gray-700 leading-relaxed" data-id="element-180">
          <p data-id="element-181">
            They were doing everything right, but their brand was holding them
            back. Within 3 months of clarity, their revenue doubled.
          </p>
        </div>
      </SlideLayout>,
  notes: 'My first client proved it.'
}, {
  id: 'definition',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="yellow" showLogo={false} data-id="element-182">
        <motion.h2 className="text-6xl md:text-9xl font-black mt-4 tracking-tighter" initial={{
      opacity: 0,
      y: 20
    }} animate={isActive ? {
      opacity: 1,
      y: 0
    } : {}} data-id="element-183">
          What branding <span className="block text-white" data-id="element-184">actually is.</span>
        </motion.h2>
      </SlideLayout>,
  notes: 'Transition to definition.'
}, {
  id: 'pret',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="light" data-id="element-185">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 h-full items-center" data-id="element-186">
          {[{
        src: PRET_COFFEE,
        alt: 'Pret'
      }, {
        src: CURRY_IMAGE,
        alt: 'Curry'
      }, {
        src: ETIHAD_PLANE,
        alt: 'Etihad'
      }].map((img, i) => <motion.div key={i} className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white h-64 md:h-80" initial={{
        opacity: 0,
        scale: 0.8,
        y: 20
      }} animate={isActive ? {
        opacity: 1,
        scale: 1,
        y: 0
      } : {}} transition={{
        delay: i * 0.2
      }} data-id="element-187">
              <img src={img.src} className="w-full h-full object-cover" alt={img.alt} data-id="element-188" />
            </motion.div>)}
        </div>
      </SlideLayout>,
  notes: 'Visual branding examples.'
}, {
  id: 'pret-2',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="light" data-id="element-189">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 h-full items-center" data-id="element-190">
          {/* Pret */}
          <motion.div className="space-y-6" initial={{
        opacity: 0,
        y: 20
      }} animate={isActive ? {
        opacity: 1,
        y: 0
      } : {}} data-id="element-191">
            <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white h-64 md:h-80" data-id="element-192">
              <img src={PRET_COFFEE} className="w-full h-full object-cover" alt="Pret" data-id="element-193" />
            </div>
            <p className="text-xl font-bold text-slate-800 leading-snug" data-id="element-194">
              "That free coffee had absolutely nothing to do with their logo. It
              was how they made me feel."
            </p>
            <img src={PRET_GESTURE_IMAGE} className="w-full rounded-2xl shadow-lg border border-slate-100" alt="Cost of gesture" data-id="element-195" />
          </motion.div>

          {/* Curry */}
          <motion.div className="space-y-6" initial={{
        opacity: 0,
        y: 20
      }} animate={isActive ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.2
      }} data-id="element-196">
            <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white h-64 md:h-80" data-id="element-197">
              <img src={CURRY_IMAGE} className="w-full h-full object-cover" alt="Curry" data-id="element-198" />
            </div>
            <p className="text-xl font-bold text-slate-800 leading-snug" data-id="element-199">
              "I remember you having this dish last time."
            </p>
          </motion.div>

          {/* Etihad */}
          <motion.div className="space-y-6" initial={{
        opacity: 0,
        y: 20
      }} animate={isActive ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.4
      }} data-id="element-200">
            <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white h-64 md:h-80" data-id="element-201">
              <img src={ETIHAD_PLANE} className="w-full h-full object-cover" alt="Etihad" data-id="element-202" />
            </div>
            <p className="text-xl font-bold text-slate-800 leading-snug" data-id="element-203">
              "Removing a number costs nothing. But it removes a reason for a
              customer to feel uncomfortable before the flight even takes off.
              That's brand protecting the experience before the experience
              begins."
            </p>
          </motion.div>
        </div>
      </SlideLayout>,
  notes: 'Visual branding examples - details.'
}, {
  id: 'case-intro',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="yellow" data-id="element-204">
        <motion.h2 className="text-6xl md:text-9xl font-black tracking-tighter leading-none max-w-5xl mb-12" initial={{
      opacity: 0,
      scale: 0.9
    }} animate={isActive ? {
      opacity: 1,
      scale: 1
    } : {}} data-id="element-205">
          Let me show you exactly what this looks like.
        </motion.h2>
      </SlideLayout>,
  notes: 'Transition to case studies.'
}, {
  id: 'hvac-prob',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="light" data-id="element-206">
        <motion.h2 className="text-6xl md:text-9xl font-black mt-4 tracking-tighter" initial={{
      opacity: 0,
      x: -50
    }} animate={isActive ? {
      opacity: 1,
      x: 0
    } : {}} data-id="element-207">
          The HVAC company.
        </motion.h2>
        <p className="text-red-500 font-bold text-3xl mt-12" data-id="element-208">
          "They pitched. They lost."
        </p>
      </SlideLayout>,
  notes: 'HVAC problem.'
}, {
  id: 'hvac-fix',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="light" data-id="element-209">
        <motion.h2 className="text-6xl md:text-9xl font-black mt-4 tracking-tighter" initial={{
      opacity: 0,
      y: 20
    }} animate={isActive ? {
      opacity: 1,
      y: 0
    } : {}} data-id="element-210">
          What we changed.
        </motion.h2>
        <p className="text-2xl md:text-4xl font-bold text-slate-700 mt-12 max-w-5xl leading-relaxed" data-id="element-211">
          We didn't change their logo. We changed their positioning – how they
          showed up in tenders, documents and presentations, so they finally
          looked as credible as the work they deliver.
        </p>
      </SlideLayout>,
  notes: 'HVAC solution.'
}, {
  id: 'hvac-res',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="dark" showLogo={false} showFooter={false} data-id="element-212">
        <div className="absolute inset-0" data-id="element-213">
          <img src={F1_VISUAL_NEW} className="w-full h-full object-cover opacity-90" alt="F1" data-id="element-214" />
        </div>
      </SlideLayout>,
  notes: 'HVAC outcome.'
}, {
  id: 'global-case',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="light" data-id="element-215">
        <div className="flex flex-col justify-center h-full max-w-5xl" data-id="element-216">
          <motion.h2 className="text-5xl md:text-8xl font-black tracking-tighter leading-none mb-8" initial={{
        opacity: 0,
        x: -50
      }} animate={isActive ? {
        opacity: 1,
        x: 0
      } : {}} data-id="element-217">
            Avery Weigh Tronix.
          </motion.h2>
          <p className="text-2xl font-bold text-gray-400 mb-12" data-id="element-218">
            Birmingham. Fortune 250. UK and Global.
          </p>
          <motion.div className="bg-slate-50 p-10 rounded-3xl border border-slate-100 italic text-2xl md:text-3xl text-slate-700 leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} animate={isActive ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.3
      }} data-id="element-219">
            "We're global, in a mature industry. Our brand looked tired. Avy
            showed us how to look like the innovator we actually are. We stayed
            the leader. We stayed relevant."
            <div className="mt-8 text-sm font-black uppercase tracking-widest text-slate-400" data-id="element-220">
              — Avery Weigh Tronix, Global company
            </div>
          </motion.div>
        </div>
      </SlideLayout>,
  notes: 'Global case study.'
}, {
  id: 'revenue',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="light" data-id="element-221">
        <div className="flex flex-col items-center justify-center h-full gap-16" data-id="element-222">
          <motion.h2 className="text-4xl md:text-6xl font-black tracking-tighter text-slate-900" initial={{
        opacity: 0
      }} animate={isActive ? {
        opacity: 1
      } : {}} data-id="element-223">
            The brand-revenue chain
          </motion.h2>

          <div className="flex flex-wrap justify-center items-center gap-4 max-w-6xl" data-id="element-224">
            {[{
          label: 'Brand Clarity',
          desc: 'People immediately understand who you are'
        }, {
          label: 'Trust',
          desc: 'Prospects feel safe choosing you'
        }, {
          label: 'Higher Prices',
          desc: 'You stop competing on cost'
        }, {
          label: 'Referrals',
          desc: 'Clients describe you clearly to others'
        }, {
          label: 'Sustainable Scale',
          desc: 'Each client brings the next'
        }].map((item, i) => <Fragment key={i} data-id="element-225">
                <motion.div className="w-48 md:w-56 bg-white p-6 rounded-2xl border border-slate-200 shadow-sm text-center space-y-3" initial={{
            opacity: 0,
            scale: 0.9
          }} animate={isActive ? {
            opacity: 1,
            scale: 1
          } : {}} transition={{
            delay: i * 0.1
          }} data-id="element-226">
                  <div className="text-[#ff3b30] font-black text-lg leading-tight" data-id="element-227">
                    {item.label}
                  </div>
                  <div className="text-slate-500 text-xs leading-relaxed" data-id="element-228">
                    {item.desc}
                  </div>
                </motion.div>
                {i < 4 && <div className="w-4 h-[2px] bg-slate-200 hidden md:block" data-id="element-229" />}
              </Fragment>)}
          </div>
        </div>
      </SlideLayout>,
  notes: 'Revenue model.'
}, {
  id: 'framework',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="light" data-id="element-230">
        <div className="flex flex-col items-center justify-center h-full" data-id="element-231">
          <motion.h2 className="text-5xl md:text-7xl font-black mb-12 tracking-tighter" initial={{
        opacity: 0,
        y: -20
      }} animate={isActive ? {
        opacity: 1,
        y: 0
      } : {}} data-id="element-232">
            The A · V · Y framework.
          </motion.h2>

          <div className="flex flex-col md:flex-row items-center justify-center gap-12 w-full max-w-6xl h-[60vh]" data-id="element-233">
            <motion.div className="flex-1 h-full w-full" initial={{
          opacity: 0,
          x: -30
        }} animate={isActive ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          delay: 0.2
        }} data-id="element-234">
              <img src={TRIANGLE_2} alt="AVY Framework Icons" className="w-full h-full object-contain" data-id="element-235" />
            </motion.div>

            <motion.div className="flex-1 h-full w-full" initial={{
          opacity: 0,
          x: 30
        }} animate={isActive ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          delay: 0.4
        }} data-id="element-236">
              <img src={TRIANGLE_1} alt="AVY Framework Letters" className="w-full h-full object-contain" data-id="element-237" />
            </motion.div>
          </div>
        </div>
      </SlideLayout>,
  notes: 'The core system.'
}, {
  id: 'align',
  component: ({
    isActive
  }: SlideProps) => <SlideLayout theme="light" showFooter={false} data-id="element-238">
        <div className="flex flex-col justify-center h-full py-8" data-id="element-239">
          <motion.h2 className="text-3xl md:text-4xl font-black mb-6 tracking-tighter text-center text-slate-900" initial={{
        opacity: 0,
        y: -20
      }} animate={isActive ? {
        opacity: 1,
        y: 0
      } : {}} data-id="element-240">
            The A · V · Y framework.
          </motion.h2>

          {/* A V Y Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-stretch max-w-7xl mx-auto w-full mb-6" data-id="element-241">
            {/* A */}
            <motion.div className="bg-gradient-to-br from-red-50 to-red-100 p-6 rounded-2xl border-2 border-red-200 flex flex-col shadow-lg" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={isActive ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          delay: 0.1
        }} data-id="element-242">
              <div className="text-6xl font-black text-[#ff3b30] mb-2 leading-none" data-id="element-243">
                A
              </div>
              <h3 className="text-2xl font-black text-slate-900 mb-1" data-id="element-244">Align</h3>
              <p className="text-red-600 font-bold mb-4 text-sm" data-id="element-245">
                Get your story locked in.
              </p>
              <ul className="space-y-2 text-slate-700 font-medium text-xs flex-1" data-id="element-246">
                <li data-id="element-247">
                  <strong className="text-slate-900" data-id="element-248">Why</strong> – the deeper
                  purpose
                </li>
                <li data-id="element-249">
                  <strong className="text-slate-900" data-id="element-250">Who</strong> – your ideal
                  client
                </li>
                <li data-id="element-251">
                  <strong className="text-slate-900" data-id="element-252">What</strong> – the outcome
                </li>
                <li data-id="element-253">
                  <strong className="text-slate-900" data-id="element-254">How</strong> – your
                  approach
                </li>
                <li data-id="element-255">
                  <strong className="text-slate-900" data-id="element-256">Where</strong> – your
                  channels
                </li>
              </ul>
            </motion.div>

            {/* V */}
            <motion.div className="bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-2xl border-2 border-green-200 flex flex-col shadow-lg" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={isActive ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          delay: 0.2
        }} data-id="element-257">
              <div className="text-6xl font-black text-[#34c759] mb-2 leading-none" data-id="element-258">
                V
              </div>
              <h3 className="text-2xl font-black text-slate-900 mb-1" data-id="element-259">
                Visualise
              </h3>
              <p className="text-green-700 font-bold mb-4 text-sm" data-id="element-260">
                Express it everywhere.
              </p>
              <ul className="space-y-2 text-slate-700 font-medium text-xs flex-1" data-id="element-261">
                <li data-id="element-262">Website, social, email, sales decks</li>
                <li data-id="element-263">Proposals, tenders, invoices</li>
                <li data-id="element-264">Logo, colours, tone of voice</li>
                <li data-id="element-265">Every touchpoint</li>
              </ul>
            </motion.div>

            {/* Y */}
            <motion.div className="bg-gradient-to-br from-yellow-300 to-yellow-400 p-6 rounded-2xl border-2 border-yellow-500 flex flex-col relative shadow-lg" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={isActive ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          delay: 0.3
        }} data-id="element-266">
              <div className="absolute top-4 right-4 text-slate-900" data-id="element-267">
                <TrendingUp size={32} strokeWidth={3} data-id="element-268" />
              </div>
              <div className="text-6xl font-black text-slate-900 mb-2 leading-none" data-id="element-269">
                Y
              </div>
              <h3 className="text-2xl font-black text-slate-900 mb-1" data-id="element-270">
                Your Outcome
              </h3>
              <p className="text-slate-800 font-bold mb-4 text-sm" data-id="element-271">
                Better clients. Right prices. Real growth.
              </p>
              <ul className="space-y-2 text-slate-800 font-medium text-xs flex-1" data-id="element-272">
                <li data-id="element-273">Better-fit clients who recognise your value</li>
                <li data-id="element-274">Easier pricing conversations</li>
                <li data-id="element-275">Word of mouth that works</li>
                <li data-id="element-276">You attract instead of chase</li>
              </ul>
              <div className="mt-4 p-3 bg-slate-900 rounded-xl text-xs font-black text-yellow-400 text-center" data-id="element-277">
                Y happens when A is locked in and V is right
              </div>
            </motion.div>
          </div>

          {/* Your Task and Tips */}
          <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-7xl mx-auto w-full" initial={{
        opacity: 0,
        y: 20
      }} animate={isActive ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.5
      }} data-id="element-278">
            {/* Your Task */}
            <div className="bg-slate-900 p-6 rounded-2xl border-2 border-slate-800 shadow-lg" data-id="element-279">
              <h3 className="text-2xl font-black text-yellow-400 mb-4" data-id="element-280">
                Your task
              </h3>
              <p className="text-white font-bold mb-3 text-sm" data-id="element-281">
                Use the AVY framework on your own business.
              </p>
              <ul className="space-y-2 text-slate-300 text-xs leading-relaxed" data-id="element-282">
                <li data-id="element-283">
                  <strong className="text-white" data-id="element-284">Align</strong> – Write one
                  simple sentence: who you help, what you help them achieve, and
                  how you do it.
                </li>
                <li data-id="element-285">
                  <strong className="text-white" data-id="element-286">Visualise</strong> – List the
                  first three places people experience your brand. Do they all
                  tell that same story?
                </li>
                <li data-id="element-287">
                  <strong className="text-white" data-id="element-288">Your Outcome</strong> – Decide
                  the result you want your brand to drive more of: better-fit
                  clients, stronger referrals, or easier growth.
                </li>
              </ul>
            </div>

            {/* Tips */}
            <div className="bg-slate-50 p-6 rounded-2xl border-2 border-slate-200 shadow-lg" data-id="element-289">
              <h3 className="text-2xl font-black text-[#ff3b30] mb-4" data-id="element-290">Tips</h3>
              <ul className="space-y-3 text-slate-700 text-xs leading-relaxed" data-id="element-291">
                <li data-id="element-292">
                  <strong className="text-slate-900" data-id="element-293">Keep it simple</strong> –
                  if it's clever but unclear, rewrite it.
                </li>
                <li data-id="element-294">
                  <strong className="text-slate-900" data-id="element-295">
                    Don't say "everyone"
                  </strong>{' '}
                  – be specific about who it's for.
                </li>
                <li data-id="element-296">
                  <strong className="text-slate-900" data-id="element-297">
                    Focus on the outcome
                  </strong>
                  , not just the service.
                </li>
              </ul>
            </div>
          </motion.div>
        </div>
      </SlideLayout>,
  notes: 'AVY Deep Dive.'
}, {
  id: 'wrapup',
  component: WrapUpSlide,
  notes: "Clarity isn't magic. It's honesty."
}, {
  id: 'summary',
  component: SummarySlide,
  notes: 'Recap of the A·V·Y system.'
}];
export function App() {
  const screenInit = useScreenInit();
  const [currentSlide, setCurrentSlide] = useState(screenInit?.currentSlide ?? 0);
  const [showNotes, setShowNotes] = useState(false);
  const [scale, setScale] = useState(1);
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const targetRatio = 1920 / 1080;
      const currentRatio = width / height;
      let newScale = 1;
      if (currentRatio > targetRatio) {
        newScale = height / 1080;
      } else {
        newScale = width / 1920;
      }
      setScale(newScale);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    if (screenInit?.currentSlide !== undefined) {
      setCurrentSlide(screenInit.currentSlide);
    }
  }, [screenInit]);
  const nextSlide = () => setCurrentSlide(prev => Math.min(prev + 1, SLIDE_CONFIG.length - 1));
  const prevSlide = () => setCurrentSlide(prev => Math.max(prev - 1, 0));
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight' || e.key === ' ') nextSlide();
      if (e.key === 'ArrowLeft') prevSlide();
      if (e.key === 'n') setShowNotes(!showNotes);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [showNotes]);
  const slide = SLIDE_CONFIG[currentSlide];
  return <div className="slide-container bg-[#0f172a] h-screen w-screen flex items-center justify-center overflow-hidden select-none" data-id="element-298">
      <div className="relative bg-white overflow-hidden shadow-2xl flex flex-shrink-0 origin-center" style={{
      width: '1920px',
      height: '1080px',
      transform: `scale(${scale})`
    }} data-id="element-299">
        <div className="relative flex-1 flex overflow-hidden" data-id="element-300">
          <AnimatePresence mode="wait" data-id="element-301">
            <motion.div key={currentSlide} initial={{
            opacity: 0,
            x: 100
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -100
          }} transition={{
            type: 'spring',
            damping: 25,
            stiffness: 200
          }} className="w-full h-full" data-id="element-302">
              {createElement(slide.component, {
              isActive: true
            })}
            </motion.div>
          </AnimatePresence>

          <AnimatePresence data-id="element-303">
            {showNotes && <motion.div initial={{
            x: '100%'
          }} animate={{
            x: 0
          }} exit={{
            x: '100%'
          }} className="absolute right-0 top-0 bottom-0 w-80 md:w-96 bg-gray-900 text-white p-8 z-50 border-l border-gray-800" data-id="element-304">
                <div className="flex justify-between items-center mb-8" data-id="element-305">
                  <h3 className="text-xs font-bold uppercase tracking-widest text-yellow-400" data-id="element-306">
                    Speaker Notes
                  </h3>
                  <button onClick={() => setShowNotes(false)} className="p-1 hover:bg-gray-800 rounded" data-id="element-307">
                    <X size={20} data-id="element-308" />
                  </button>
                </div>
                <p className="text-lg leading-relaxed font-medium text-gray-300 italic" data-id="element-309">
                  "{slide.notes}"
                </p>
              </motion.div>}
          </AnimatePresence>
        </div>

        {/* Navigation Controls */}
        <div className="fixed bottom-16 md:bottom-24 right-8 md:right-12 flex items-center gap-3 z-[100]" data-id="element-310">
          <button onClick={prevSlide} className="p-4 md:p-3 bg-white/90 backdrop-blur hover:bg-white text-slate-400 hover:text-slate-900 rounded-full shadow-xl transition-all active:scale-90 border border-slate-100" title="Previous (ArrowLeft)" data-id="element-311">
            <ChevronLeft size={24} className="md:w-5 md:h-5" data-id="element-312" />
          </button>
          <div className="px-4 py-2 text-sm md:text-xs text-slate-600 font-black bg-white/70 backdrop-blur rounded-xl border border-slate-100/50 shadow-sm" data-id="element-313">
            {currentSlide + 1} / {SLIDE_CONFIG.length}
          </div>
          <button onClick={nextSlide} className="p-4 md:p-3 bg-slate-900 text-white rounded-full shadow-xl transition-all active:scale-90" title="Next (ArrowRight / Space)" data-id="element-314">
            <ChevronRight size={24} className="md:w-5 md:h-5" data-id="element-315" />
          </button>
          <button onClick={() => setShowNotes(!showNotes)} className={`p-4 md:p-3 rounded-full shadow-xl transition-all active:scale-90 ${showNotes ? 'bg-yellow-400 text-black' : 'bg-white/80 backdrop-blur text-slate-400 border border-slate-100'}`} title="Speaker Notes (N)" data-id="element-316">
            <MessageSquare size={24} className="md:w-5 md:h-5" data-id="element-317" />
          </button>
        </div>
      </div>
    </div>;
}